// Segmented Turkish machine draft, preserved as editorial review material only.
import a from './tr_a.js';
import b1 from './tr_b1.js';
import b2 from './tr_b2.js';
import c from './tr_c.js';
import d from './tr_d.js';
import e from './tr_e.js';
import f from './tr_f.js';
export default Object.freeze({
  ...a, ...b1, ...b2, ...c, ...d, ...e, ...f,
  'words.scbu.term': 'SCBU',
  'words.nicu.term': 'NICU',
  'words.hdu.term': 'HDU',
  'words.cpap.term': 'CPAP',
  'words.saturation-spo.term': 'Saturation (SpO₂)',
});
